import { Box, Typography } from "@mui/material";
import MSmallStoreCard from "features/searchStore/components/MSmallStoreCard";
import SmallStoreCard from "features/searchStore/components/SmallStoreCard";

export function MRelatedStoreSection() {
  return (
    <Box display="flex" flexDirection="column" px={2} bgcolor="white">
      <Typography variant="h5" fontWeight="bold" sx={{ my: 2 }}>
        こちらとよく一緒に閲覧されているレストラン
      </Typography>
      <Box py={1} sx={{ overflowX: "auto", whiteSpace: "nowrap" }}>
        <Box mx={1} sx={{ display: "inline-block" }}>
          <SmallStoreCard
            imgPath="/images/store-detail/store1.avif"
            name="オリエンタルラウンジ／マンダリン オリエンタル 東京"
            area="日本橋"
            point={4.54}
          />
        </Box>

        <Box mx={1} sx={{ display: "inline-block" }}>
          <SmallStoreCard
            imgPath="/images/store-detail/store2.avif"
            name="WASHOKU 蒼天 SOUTEN／ザ・プリンスギャラリー 東京紀尾井町，ラグジュアリーコレクションホテル"
            area="赤坂見附・永田町"
            point={4.33}
          />
        </Box>

        <Box mx={1} sx={{ display: "inline-block" }}>
          <SmallStoreCard
            imgPath="/images/store-detail/store3.avif"
            name="All-Day Dining OASIS GARDEN／ザ・プリンスギャラリー 東京紀尾井町，ラグジュアリーコレクションホテル"
            area="赤坂見附・永田町"
            point={4.28}
          />
        </Box>

        <Box mx={1} sx={{ display: "inline-block" }}>
          <SmallStoreCard
            imgPath="/images/store-detail/store4.avif"
            name="Peter／ザ・ペニンシュラ東京"
            area="日比谷"
            point={4.33}
          />
        </Box>

        <Box mx={1} sx={{ display: "inline-block" }}>
          <SmallStoreCard
            imgPath="/images/store-detail/store5.avif"
            name="つきじ治作"
            area="築地"
            point={4.62}
          />
        </Box>
      </Box>
    </Box>
  );
}
